export default __webpack_public_path__ + "static/media/influxdb.e5e4aec3.svg";